/** Une carte chiffre. */
import { ProgressBar } from "./ProgressBar";
import type { DashKpi } from "./types";

type KpiCardProps = {
  kpi: DashKpi;
  onOpen?: (kpi: DashKpi) => void;
};

export function KpiCard({ kpi, onOpen }: KpiCardProps) {
  const inner = (
    <>
      <dl>
        <dt>{kpi.label}</dt>
        <dd>{kpi.value}</dd>
      </dl>
      <p className="fx-kpi__hint">{kpi.hint}</p>
      <ProgressBar
        value={kpi.bar ?? 0}
        tone={kpi.tone === "warn" ? "warn" : "accent"}
        label={kpi.label}
      />
    </>
  );
  const cls = `fx-kpi${kpi.tone === "warn" ? " fx-kpi--warn" : ""}`;
  if (!onOpen) {
    return <article className={cls}>{inner}</article>;
  }
  return (
    <button type="button" className={cls} onClick={() => onOpen(kpi)}>
      {inner}
    </button>
  );
}
